import { Route, Routes } from "react-router-dom";
import LegalDocumentsPortalRoute from "./private-route";
import Home from "../components/home";
import DocumentDetails from "../components/legal-documents/document-details";
import CreateLegalDocument from "../components/legal-documents/create-legal-document";

const LegalDocumentsPortalRoutes = () => {
  return (
    <Routes>
      <Route exact path='/' element={<LegalDocumentsPortalRoute />}>
        <Route exact path='/' element={<Home />} />
        <Route
          exact
          path='legal-document-details/:id'
          element={<DocumentDetails />}
        />       
         <Route
          exact
          path='create-legal-document'
          element={<CreateLegalDocument />}
        /> 
      </Route>
    </Routes>
  );
};

export default LegalDocumentsPortalRoutes;
